export function getSpecialLeaveReasonsForDownload(
  absences: ReadonlyArray<{ id: string; reason?: string | null }>,
  drafts: Readonly<Record<string, string>>,
) {
  return Object.fromEntries(
    absences.map((absence) => [
      absence.id,
      drafts[absence.id] ?? absence.reason ?? "",
    ]),
  );
}
